import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import {  Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'

const HD = [

    {
        "Name": "Prof. Anki Reddy Katha",
        "NameLink": "/dr-anki-reddy-katha",
        "Position": "Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India.",
        "AreasofInterest": "Energy and Environmental Sciences, Granular Physics.",
        "Phone": "0877 250 3050",
        "Email": "hod_ch@iittp.ac.in / anki.reddy@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/anki.jpg"

    }
]
const Faculty = [
   

    {
        "Name": "Prof.  Arun K. Tangirala",
        "NameLink": "/prof-arun-k-tangirala",
        "Position": "Professor",
        "Degree": "Ph.D - University of Alberta, Edmonton.",
        "AreasofInterest": "Process Systems Engineering, Data Science & Artificial Intelligence",
        "Phone": "0877 250 3025",
        "Email": "arunkt@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof_Arun_K_Tangirala.png"
    },
    
    
   
    {
        "Name": "Dr. Sasidhar Gumma",
        "NameLink": "/dr-sasidhar-gumma",
        "Position": "Professor",
        "Degree": "Ph.D - Cleveland State University",
        "AreasofInterest": "Metal organic frameworks, Adsorption.",
        "Phone": "0877 250 3726 / 3053",
        "Email": "s.gumma@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/SG.jpg"
    },
    {
        "Name": "Prof.Thamida Sunil Kumar",
        "NameLink": "/dr-thamida-sunil-kumar",
        "Position": "Professor",
        "Degree": "Ph.D - University of Notre Dame, USA.",
        "AreasofInterest": "Microfluidics and Corrosion Simulation.",
        "Phone": "0877 250 3058",
        "Email": "sunil76@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Thamida_sunil_kumar_2019.jpg" 
    },
    {
        "Name": "Dr. Bijoy Kumar Das",
        "NameLink": "/dr-bijoy-kumar-das",
        "Position": "Associate Professor",
        "Degree": "Ph.D - National University of Singapore (NUS), Singapore",
        "AreasofInterest": "Advanced Battery Materials and Chemistries, Battery Manufacturing and Scalability",
        "Phone": " ",
        "Email": "bijoy@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Bijoy_Kumar_Das.png"
    },
    {
        "Name": "Dr. M Nabil",
        "NameLink": "/dr-m-nabil",
        "Position": "Associate Professor",
        "Degree": "Ph.D - IIT Madras, India.",
        "AreasofInterest": "Process Optimization & Control, Machine Learning for Process Systems",
        "Phone": "0877 250 3065",
        "Email": "nabil@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Nabil.png"
    },

     {
        "Name": "Dr. Narendra Singh",
        "NameLink": "/dr-narendra-singh",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India.",
        "AreasofInterest": "Photocatalysis, Surface engineering of polymer and metal surfaces",
        "Phone": "0877 250 3066",
        "Email": "narendra@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Narendra Singh.jpg"
    },
    {
        "Name": "Dr. Ranjith Thangavel",
        "NameLink": "/dr-ranjith-thangavel",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Chonnam National University, South Korea",
        "AreasofInterest": "Li-ion batteries, Na-ion batteries and beyond, Catalysis for electrochemical energy conversion",
        "Phone": "0877 250 3061",
        "Email": "ranjith.t@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Ranjith_AP.png"
    },
    
    {
        "Name": "Dr. Anil Vir",
        "NameLink": "/dr-anil-vir",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology (IIT) Madras, India.",
        "AreasofInterest": "Microreactor and multiphase reaction",
        "Phone": "877 250 3057",
        "Email": "anilvir@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/anilvir.jpg"
    },
    {
        "Name": "Dr. Brindha Moorthy",
        "NameLink": "/dr-brindha-moorthy",
        "Position": "Assistant Professor",
        "Degree": "Ph.D., KAIST, South Korea.",
        "AreasofInterest": "Materials Science and Engineering, Functional Materials for Energy Storage Applications.",
        "Phone": "0877 250 3060",
        "Email": "brindha.m@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr.Brindha_Moorthy_AP.jpg"
    },
    
   
    {
        "Name": "Dr. Nilesh Choudhary",
        "NameLink": "/dr-nilesh-choudhary",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Academy of Scientific and Innovative Research (CSIR-NCL)",
        "AreasofInterest": "Multi-scale molecular simulation for applied materials and complex systems",
        "Phone": "0877 250 3064",
        "Email": "nilesh@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/nilesh.jpeg"
    },
    {
        "Name": "Dr. Payel Sen",
        "NameLink": "/dr-payel-sen",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - University of Alberta, Canada",
        "AreasofInterest": "Electrochemical biosensing, Sensor system engineering",
        "Phone": "0877 250 3063",
        "Email": "psen@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/payel_sen_ap.png"
    },
    
    {
        "Name": "Dr. Shamik Misra",
        "NameLink": "/dr-shamik-misra",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian institute of Technology Bombay, India",
        "AreasofInterest": "Process systems engineering, Renewable energy, and sustainability",
         "Phone": "0877 250 3059",
        "Email": "misra@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/misra.PNG"
    },
    {
        "Name": "Dr. Trivikram Nallamilli",
        "NameLink": "/dr-trivikram-nallamilli",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Colloid and interfacial Phenomena, Soft matter and Food physics",
         "Phone": "0877 250 3056",
        "Email": "trivikram@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/trivikram.jpg"
    },
    {
        "Name": "Dr. S Uday Kumar",
        "NameLink": "/dr-s-uday-kumar",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - IIT - Roorkee, Roorkee, India",
        "AreasofInterest": "Nanobiotechnology and Biomaterials",
         "Phone": "0877 250 3062",
        "Email": "udaykumar@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/uday.jpg"
    }




]

const FormerFaculty = [


    {
        "Name": "Prof. KSMS Raghavarao",
        "NameLink": "/dr-ksms-raghavarao",
        "Position": "Visiting Professor",
        "Degree": "Ph.D - Institute of Chemical Technology (UICT), Mumbai, India.",
        "AreasofInterest": "Food Process Engineering; Separation Processes.",
        "Phone": "0877 250 3417 ",
        "Email": "raghava@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/raghavarao.png"
    },


]

const GuestFaculty = [


   
    {
        "Name": "Dr. K Raghunathan",
        "NameLink": "#",
        "Position": "Professor of Practice",
        "Degree": "Ph.D. - West Virginia University",
        "AreasofInterest": "Battery Cell Technology",
        "Phone": " ",
        "Email": "raghuk@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Raghu_photo.jpg"
    },
   


]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="CHEMICAL ENGINEERING" />
            <section className="team-area fix p-relative pt-120 pb-80" >
                 

                <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                            
                            <h3>CHEMICAL ENGINEERING</h3>
                        </div>
                    </div>
                </div>

                <div className="container">


                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={1} />
                        </Col>
                        <Col md={9} className='c-right'>

                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{Faculty.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={HD.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> <b>Email</b> : {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> <b>Email</b> : {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                                  {/*--------------------------- Adjunct Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Visiting Faculty</h3>
                                {FormerFaculty.map((FormerFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={FormerFaculty.NameLink}>
                                                        <img src={FormerFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={FormerFaculty.NameLink}>{FormerFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{FormerFaculty.Position}</p>
                                                    <p className="text-dark">{FormerFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {FormerFaculty.AreasofInterest}</p>

                                                    {(FormerFaculty.Phone !== undefined && FormerFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{FormerFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {FormerFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                              {/*--------------------------- Guest Faculty*/}
                                                        <div className="row">
                                                            <h3 className='c-headline mt-5 mb-5'>Professors of Practice</h3>
                                                            {GuestFaculty.map((GuestFaculty, index) => (
                                                                <div key={index} className="col-xl-4 col-md-6">
                                                                    <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                                                        <div className="team-thumb">
                                                                            <div className="brd">
                                                                                <Link to={GuestFaculty.NameLink}>
                                                                                    <img src={GuestFaculty.Image} alt="img" />
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                        <div className="team-info">
                                                                            <h4 className='c-link'>
                                                                                <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                                            </h4>
                            
                                                                            <div className="text-dark c-lineheight2">
                                                                               <p className="text-dark fw-bold">  <i className='fw-bold text-dark fal fa-graduation-cap me-2' /> {GuestFaculty.Position}</p>
                                                                                <p className="text-dark">{GuestFaculty.Degree}</p>
                                                                                <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {GuestFaculty.AreasofInterest}</p>
                            
                                                                                {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                                                    <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                                                )}
                                                                                <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>


                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main